// extracted by mini-css-extract-plugin
module.exports = {"Billboard":"BulletinBoard_Billboard__3h0_U"};